import { useEffect, useState } from 'react';

const isDesktop = window.matchMedia('(min-width: 992px)').matches;
const isMobile = window.matchMedia('(max-width: 428px)').matches;

const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;

export function isTabletOrLowerOnResize(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= breakpoint : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= breakpoint);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
}

export { isDesktop, isMobile, isTouchDevice };
